import { render, staticRenderFns } from "./FigurePanel.vue?vue&type=template&id=63565bdc&"
import script from "./FigurePanel.vue?vue&type=script&lang=js&"
export * from "./FigurePanel.vue?vue&type=script&lang=js&"
import style0 from "./FigurePanel.vue?vue&type=style&index=0&id=63565bdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports